import { CustomComponentProps } from "utils/types/generalTypes";
// import avatar from "assets/img/avatars/jenna.png";
import { IconInput, SVG, ToolTipV2 } from "ui";
import { useRef, useState } from "react";
import useWindowSize from "utils/hooks/useWindowSize";
import { Link, useNavigate } from "react-router-dom";
import { useOnClickOutside } from "usehooks-ts";
import { useSelector } from "react-redux";
import { RootState } from "services/redux/store";
import IndirectModal from "../modals/IndirectModal";

export type SideNavProps = CustomComponentProps & {
    fold: "is-fold" | "";
    setOpenSidebar: React.Dispatch<React.SetStateAction<boolean>>;
    toggle: Function;
    currentPage: string;
};

const SideNav = ({
    fold,
    toggle,
    currentPage,
    setOpenSidebar,
    className,
    style
}: SideNavProps) => {
    const { avatar, name, userName } = useSelector(
        (state: RootState) => state.account
    );

    const [searchValue, setSearchValue] = useState("");
    const handeChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
    };

    // const [width]
    const [windowWidth] = useWindowSize();

    // close side bar on click outside
    const sideBarRef = useRef(null);
    const handleClickOutside = () => {
        setOpenSidebar(false);
    };
    useOnClickOutside(sideBarRef, handleClickOutside);

    // open inderct followers modal
    const [openModal, setOpenModal] = useState(false);

    const navigate = useNavigate();
    const handleSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (searchValue.length) {
            setSearchValue("");
            navigate(`/search/${searchValue}`);
        } else {
            return;
        }
    };

    return (
        <>
            <div
                className={`sidebar-v1 ${windowWidth >= 992 ? "" : fold} ${className}`}
                style={style}
                ref={sideBarRef}
            >
                <div className="top-section gap-20">
                    <button
                        id="sidebar-v1-close"
                        className="close-button"
                        onClick={() => toggle()}
                    >
                        <SVG
                            svg="arrow-left"
                            size={24}
                            className="light-grey-svg"
                        />
                    </button>

                    <form onSubmit={(e) => handleSubmit(e)}>
                        <IconInput
                            value={searchValue}
                            handleChange={handeChangeSearchValue}
                            placeHolder="Search..."
                            svgColor="light-grey-svg"
                        />
                    </form>

                    <div className="d-flex flex-j-end w-full">
                        <ToolTipV2 className="text-center" text="Add User">
                            <Link to="/add-user">
                                <SVG
                                    svg="add-user"
                                    size={26}
                                    className=" mr-15"
                                />
                            </Link>
                        </ToolTipV2>
                    </div>

                    <div className="user-block">
                        <img
                            className="avatar"
                            src={avatar}
                            // src="https://via.placeholder.com/150x150"
                            // data-demo-src="assets/img/avatars/jenna.png"
                            alt=""
                        />
                        <div className="meta">
                            <Link to={`/profile/${userName}`} className="">
                                <span>{name}</span>
                                {/* <span></span> */}
                                <span>@{userName}</span>
                            </Link>
                        </div>
                    </div>

                    <div className="d-flex flex-j-between w-full flex-a-start gap-5">
                        <ToolTipV2 className="text-center" text="Followers">
                            <Link
                                to={`/profile/${userName}/followers/1`}
                                className="d-flex flex-col flex-j-start flex-a-center gap-5 "
                            >
                                <div className="svg-nav-circle">
                                    <SVG svg="follow" size={22} />
                                </div>
                                {/* <span className="momeento-p white-text fs-90">
                            Followers
                        </span> */}
                                <span className="momeento-p white-text fs-90">
                                    8
                                </span>
                            </Link>
                        </ToolTipV2>

                        <ToolTipV2
                            className="text-center"
                            text="Indirect Followers"
                        >
                            <div
                                className="d-flex flex-col flex-j-start flex-a-center gap-5 "
                                onClick={() => setOpenModal(true)}
                            >
                                <div className="svg-nav-circle">
                                    <SVG svg="curved-arrow" size={22} />
                                </div>
                                <span className="momeento-p white-text fs-90">
                                    10
                                </span>
                            </div>
                        </ToolTipV2>

                        <ToolTipV2 className="text-center" text="Following">
                            <Link
                                to={`/profile/${userName}/following/1`}
                                className="d-flex flex-col flex-j-start flex-a-center gap-5 "
                            >
                                <div className="svg-nav-circle">
                                    <SVG svg="followed" size={22} />
                                </div>
                                <span className="momeento-p white-text fs-90">
                                    3
                                </span>
                            </Link>
                        </ToolTipV2>
                    </div>
                </div>
                <div className="bottom-section">
                    <ul>
                        <li>
                            <Link
                                to="/"
                                className={`${
                                    currentPage.toLowerCase() == "home"
                                        ? "is-active"
                                        : ""
                                }`}
                            >
                                <SVG
                                    svg="home"
                                    size={18}
                                    // className={`${currentPage.toLowerCase() == "feed" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                    className={`${
                                        currentPage.toLowerCase() == "home"
                                            ? "blue-svg"
                                            : "light-grey-svg"
                                    } mr-15`}
                                />
                                <span>Home</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/incidents"
                                className={`${currentPage.toLowerCase() == "incidents" ? "is-active" : ""}`}
                            >
                                <SVG
                                    svg="i-triangle"
                                    size={18}
                                    className={`${currentPage.toLowerCase() == "incidents" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                />
                                <span>Incidents</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/communities"
                                className={`${currentPage.toLowerCase() == "community" || currentPage.toLowerCase() == "communities" ? "is-active" : ""}`}
                            >
                                <SVG
                                    svg="community"
                                    size={18}
                                    className={`${currentPage.toLowerCase() == "community" || currentPage.toLowerCase() == "communities" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                />
                                <span>Community</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/map"
                                className={`${currentPage.toLowerCase() == "map" ? "is-active" : ""}`}
                            >
                                <SVG
                                    svg="map"
                                    size={18}
                                    className={`${currentPage.toLowerCase() == "map" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                />
                                <span>Map</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/topics"
                                className={`${currentPage.toLowerCase() == "topics" ? "is-active" : ""}`}
                            >
                                <SVG
                                    svg="topics"
                                    size={18}
                                    className={`${currentPage.toLowerCase() == "topics" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                />
                                <span>Topics</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/activity"
                                className={`${currentPage.toLowerCase() == "activity" ? "is-active" : ""}`}
                            >
                                <SVG
                                    svg="spark"
                                    size={18}
                                    className={`${currentPage.toLowerCase() == "activity" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                />
                                <span>Activity</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/notifications"
                                className={`${currentPage.toLowerCase() == "notifications" ? "is-active" : ""}`}
                            >
                                <SVG
                                    svg="bell"
                                    size={18}
                                    className={`${currentPage.toLowerCase() == "notifications" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                />
                                <span>Notifications</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/trending"
                                className={`${currentPage.toLowerCase() == "trending" ? "is-active" : ""}`}
                            >
                                <SVG
                                    svg="trending"
                                    size={18}
                                    className={`${currentPage.toLowerCase() == "trending" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                />
                                <span>Trending</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/momentmark"
                                className={`${currentPage.toLowerCase() == "momentmarks" ? "is-active" : ""}`}
                            >
                                <SVG
                                    svg="bookmark"
                                    size={18}
                                    className={`${currentPage.toLowerCase() == "momentmarks" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                />
                                <span>MomentMarks</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`/profile/${userName}`}
                                className={`${currentPage.toLowerCase() == "profile" ? "is-active" : ""}`}
                            >
                                <SVG
                                    svg="user"
                                    size={18}
                                    className={`${currentPage.toLowerCase() == "profile" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                />
                                <span>Profile</span>
                            </Link>
                        </li>
                    </ul>
                    <ul className="pb-30">
                        <li>
                            <Link
                                to="/settings"
                                className={`${currentPage.toLowerCase() == "settings" ? "is-active" : ""}`}
                            >
                                <SVG
                                    svg="settings"
                                    size={18}
                                    className={`${currentPage.toLowerCase() == "settings" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                />
                                <span>Settings</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/help"
                                className={`${currentPage.toLowerCase() == "help" ? "is-active" : ""}`}
                            >
                                <SVG
                                    svg="help"
                                    size={18}
                                    className={`${currentPage.toLowerCase() == "help" ? "blue-svg" : "light-grey-svg"} mr-15`}
                                />
                                <span>Help</span>
                            </Link>
                        </li>
                        <li>
                            <a href="#">
                                <SVG
                                    svg="logout"
                                    size={18}
                                    className="light-grey-svg mr-15"
                                />
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <IndirectModal open={openModal} setOpen={setOpenModal} />
        </>
    );
};

export default SideNav;
